import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[noDataContent]",
  standalone: false
})
export class ContainerNoDataContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
